import { Box } from '@mui/material';
import React from 'react';
import { ActionButton } from '../../ActionButton';
export const GlobalActionsSmall = (props) => {
    if (props.globalActions && props.globalActions.length > 0) {
        return (React.createElement(Box, { sx: {
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
            } }, props.globalActions.map((action) => (React.createElement(ActionButton, { key: action.label, action: action, variant: 'outlined', sx: { flexGrow: 1 } })))));
    }
    else {
        return null;
    }
};
